import React, { useEffect, useState } from 'react';
import styles from './AdminUserSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { userSingle } from '../../../redux/actions/user/userSingle';
import { resetUpdateUser, resetUserSingle } from '../../../redux/slices/user.slice';
import { useDispatch } from 'react-redux';
import { updateUser } from '../../../redux/actions/user/updateUser';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';

const AdminUserSingle = () => {
  const data = [
    [
      {
        label: 'Аватар',
        type: 'image',
        name: 'avatar',
        width: '200px',
      },
      [
        {
          label: 'Имя',
          type: 'text',
          name: 'firstName',
        },
        { label: 'Фамилия', type: 'text', name: 'lastName' },

        {
          label: 'Дата рождения',
          type: 'date',
          name: 'birthDate',
        },
        {
          type: 'radio',
          name: 'isFemale',
          label: 'Пол',
          options: [
            {
              label: 'Мужской',
              value: 'false',
            },
            {
              label: 'Женский',
              value: 'true',
            },
          ],
        },
      ],
    ],
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ user: { gradeId, clubId, firstName, lastName, avatar, isFemale, cityId, citizenshipId, birthDate, email, phone }, clubs, grades, citizenships, cities }) => {
    const fields = [
      [
        {
          label: 'Страна',
          type: 'select',
          name: 'citizenshipId',
          options: citizenships?.map((club) => ({ value: club?.id, label: club?.name })),
        },
        {
          label: 'Город',
          type: 'select',
          name: 'cityId',
          options: cities?.map((club) => ({ value: club?.id, label: club?.name })),
        },
      ],
      [
        {
          label: 'Домашний клуб',
          type: 'select',
          name: 'clubId',
          options: clubs?.map((club) => ({ value: club?.id, label: club?.name })),
        },
        {
          label: 'Уровень игры',
          type: 'select',
          name: 'gradeId',
          options: grades?.map((club) => ({ value: club?.id, label: club?.name })),
        },
      ],
      [
        {
          label: 'Телефон',
          type: 'number',
          name: 'phone',
          format: '+7 (###) ### ## ##',
        },
        {
          required: false,
          label: 'Email',
          type: 'text',
          name: 'email',
          rules: {
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: 'Неверный формат почты',
            },
          },
        },
      ],
    ];
    setFields([...data, ...fields]);
    return { clubId, firstName, lastName, avatar, isFemale: isFemale ? 'true' : 'false', gradeId, cityId, citizenshipId, birthDate, email, phone };
  };
  const deleteProps = { successText: 'Пользователь удален', confirmTitle: `Вы уверены что хотите удалить пользователя`, status: 'DELETED' };
  const blockProps = { successText: 'Пользователь заблокирован', confirmTitle: `Вы уверены что хотите заблокировать пользователя`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Пользователь разблокирован', confirmTitle: `Вы уверены что хотите разблокировать пользователя`, status: 'ACTIVE' };
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    updateUser: { data: updateUserData, loading: updateUserLoading },
  } = useSelector((state) => state.user);
  const navigate = useNavigate();
  useEffect(() => {
    if (updateUserData) {
      toast.success('Пользователь обновлен');
      navigate('/admin/users');
      dispatch(resetUpdateUser());
    }
  }, [updateUserData]);

  return (
    <>
      <AdminSinglePage
        onSubmit={(data) => {
          dispatch(updateUser({ userId: id, ...data, phone: data?.phone.replace(/\D/g, '').slice(1), isFemale: data?.isFemale == 'true' ? true : false, birthDate: new Date(data?.birthDate) }));
        }}
        reset={resetUserSingle}
        fetch={userSingle}
        sliceName={'user'}
        actionName={'userSingle'}
        onFormatData={onFormatData}
        fields={fields}
        isSave
        pathList="/admin/users"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'user'}
        type={'USER'}
      />
      {updateUserLoading && <Loading />}
    </>
  );
};

export default AdminUserSingle;
